import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CheckOutlined } from '@ant-design/icons';
import styles from './styles.module.less';

const SelectableCard = ({
  icon,
  iconName,
  title,
  subtitle,
  description,
  selected = false,
  onClick,
  className = '',
}) => {
  const renderIcon = () => {
    if (icon) {
      return <div className={styles.iconWrapper}>{icon}</div>;
    }
    if (iconName) {
      return (
        <span className={classNames('material-symbols-outlined', styles.icon)}>
          {iconName}
        </span>
      );
    }
    return null;
  };

  return (
    <div
      className={classNames(styles.card, selected && styles.selected, className)}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <div className={styles.iconContainer}>
        {renderIcon()}
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        {description && <div className={styles.description}>{description}</div>}
      </div>
      {selected && (
        <div className={styles.checkmark}>
          <CheckOutlined />
        </div>
      )}
    </div>
  );
};

SelectableCard.propTypes = {
  icon: PropTypes.node,
  iconName: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default SelectableCard;

